import { render, staticRenderFns } from "./NoMedia.vue?vue&type=template&id=cf6c82a4&scoped=true"
import script from "./NoMedia.vue?vue&type=script&lang=ts"
export * from "./NoMedia.vue?vue&type=script&lang=ts"
import style0 from "./NoMedia.vue?vue&type=style&index=0&id=cf6c82a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6c82a4",
  null
  
)

export default component.exports